export default "__VITE_ASSET__f37c864a__"